import F84Game from "../Game";

export default class MusicManager {
	private _game: F84Game;
	private _currentMusic: Phaser.Sound.BaseSound;
	private _currentKey: string;
	private _volume: number;
	private _muted: boolean;

	get muted(): boolean {
		return this._muted;
	}

	set muted(value: boolean) {
		this._muted = value;
		if (value) this.pause();
		else this.resume();
	}

	get volume(): number {
		return this._volume;
	}
	set volume(value: number) {
		this._volume = value;
		if (this._currentMusic) {
			if (this._currentMusic instanceof Phaser.Sound.WebAudioSound || this._currentMusic instanceof Phaser.Sound.HTML5AudioSound) {
				this._currentMusic.setVolume(this._volume);
			}
		}
	}

	constructor(game: F84Game, volume: number) {
		this._game = game;
		this._volume = volume;
		this._muted = false;
	}

	public play(key: string, seek = 0): void {
		if (key == this._currentKey) return;
		if (this._currentMusic) this._currentMusic.destroy();
		this._currentMusic = this._game.sound.add(key, {
			volume: this._volume,
			loop: true,
		});
		this._currentMusic.play({ seek: seek });
		this._currentKey = key;
	}

	public playWithIntro(introKey: string, loopKey: string): void {
		if (introKey == this._currentKey) return;
		this.stop();
		this._currentMusic = this._game.sound.add(introKey, { volume: this._volume, loop: false });
		this._currentMusic.on(
			Phaser.Sound.Events.COMPLETE,
			() => {
				this._currentMusic = this._game.sound.add(loopKey, { volume: this._volume, loop: true });
				this._currentMusic.play();
				this._currentKey = loopKey;
			},
			this
		);
		this._currentMusic.play();
	}

	public getPlaybackTime(): number {
		if (this._currentMusic) {
			if (this._currentMusic instanceof Phaser.Sound.WebAudioSound || this._currentMusic instanceof Phaser.Sound.HTML5AudioSound) {
				return this._currentMusic.seek;
			}
		}
		return 0;
	}

	public stop(): void {
		if (this._currentMusic) {
			this._currentMusic.removeAllListeners(Phaser.Sound.Events.COMPLETE);
			this._currentMusic.destroy();
			this._currentMusic = null;
		}
		this._currentKey = "";
	}

	public pause(): void {
		if (this._currentMusic) this._currentMusic.pause();
	}

	public resume(): void {
		if (this._currentMusic) this._currentMusic.resume();
	}
}
